import { takeLatest, select, call } from 'redux-saga/effects';
import { sendName, facebookAuth } from 'api';
import { TELEPHONE_CODE } from 'config';

import { getStorage } from 'utilz';

import * as actions from './actions';

function* sendHandl(action) {
  const state = yield select();
  const { payload: { callback, isFacebook } } = action;
  const { name: { name }, phone: { phone } } = state;
  const number = phone && phone !== '' ? phone : getStorage().phone && getStorage().phone.phone;
  try {
    if (isFacebook) {
      // console.log(phone);
      // yield call(facebookAuthProccess);
      yield call(facebookAuth, `${TELEPHONE_CODE}${number}`);
      // console.log(result);
    } else {
      yield call(sendName, name);
    }

    if (callback) {
      callback();
    }
  } catch (err) {
    console.log(err);
  }
}

export default function* () {
  yield takeLatest(
    actions.NAME_SEND,
    sendHandl
  );
}



// WEBPACK FOOTER //
// ./src/pages/Name/saga.js